const LargeArrow = () => (
  <svg width="309" height="6" viewBox="0 0 309 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M309 3L304 0.113249V5.88675L309 3ZM0 3.5H304.5V2.5H0V3.5Z" fill="#6C6596" />
  </svg>
)

export default LargeArrow
